export default class RenderComponentDirective {
    static $inject = ['$compile'];

    constructor($compile) {
        'ngInject';
        this.restrict = 'A';
        this.replace = true;
        this.scope = false;
        this.$compile = $compile;
        this.link = this.link.bind(this);
    }

    transformToHtml(component) {
        return `<${component}></${component}>`;
    }

    link(scope, element, attrs) {
        this.current = null;
        const unwatch = attrs.$observe('renderComponent', value => {
            if (this.current !== value) {
                this.current = value;
                const markup = this.$compile(this.transformToHtml(this.current))(scope);
                element.html(markup);
            }
        });
        scope.$on('$destroy', unwatch);
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/render-component/render-component.directive.js